import Index from 'fastboot-admin/src/views/common/Index.vue'

export default [
    {
        path: '/',
        name: 'index',
        meta: {tab: false},
        component: Index,
        children: [
            {
                path: '/',
                name: 'home',
                meta: {title: '首页', tab: false, hideHeader: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/Home'),
            },
            {
                path: '/sp-device/list',
                name: 'sp-device-list',
                meta: {title: '设备列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-device/List'),
            },
            {
                path: '/sp-device/add',
                name: 'sp-device-add',
                meta: {title: '新增设备', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-device/Add'),
            },
            {
                path: '/sp-device/edit',
                name: 'sp-device-edit',
                meta: {title: '编辑设备', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-device/Edit'),
            },
            {
                path: '/sp-device/detail',
                name: 'sp-device-detail',
                meta: {title: '设备详情', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-device/Detail'),
            },
            {
                path: '/sp-dev-server/list',
                name: 'sp-dev-list',
                meta: {title: '设备服务器列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-dev-server/List'),
            },
            {
                path: '/sp-dev-server/add',
                name: 'sp-dev-server-add',
                meta: {title: '新增设备服务器', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-dev-server/Add'),
            },
            {
                path: '/sp-dev-server/edit',
                name: 'sp-dev-server-edit',
                meta: {title: '编辑设备服务器', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-dev-server/Edit'),
            },
            {
                path: '/sp-dev-log/list',
                name: 'sp-dev-log-list',
                meta: {title: '设备日志列表', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/sp-dev-log/List'),
            }
        ]
    }
]
;
